import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import "../../assets/styles/local/AddPurchasingOrder.css";
import "../../assets/styles/local/ConfirmPurchasingOrder.css";
import Header from "../../layouts/Header";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
// import { FetchProductBysupplierid } from "../../redux/actions/action";
import {
  GetPOList,
  FetchPurchasingOrder,
  ApprovePO,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import downarrow from "../../assets/icons/downarrow.svg";
import packageIcon from "../../assets/icons/package.svg";
import loadingIcon from "../../assets/icons/loading2.gif";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import ColorTag from "./ColorTag";
import { Image } from "react-bootstrap";
import meh from "../../assets/icons/meh.svg";
import smaliIcon from "..//../assets/icons/meh.svg";
import "../../assets/styles/local/PurchaseOrder.css";

const PurchaseOrder = () => {
  const dispatch = useDispatch();
  const { purchaseOrderID } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { supplierid, suppliername, projectname, quoteId, quoteCode } =
    location.state ? location.state : null;
  //   const [fetchProductsData, setFetchProductsData] = useState([]);
  //   const [totalExclusiveBtw, setTotalExclusiveBtw] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [activePageOption, setActivePageOption] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [orderSelectAll, setOrderSelectAll] = useState(false);
  const [radioSelections, setRadioSelections] = useState([]);
  const [poList, setPOList] = useState([]);
  const [poApproved, setPOApproved] = useState(false);
  const [loading, setLoading] = useState(false);
  //   const fetchProductBySupplierIdList = useSelector(
  //     (state) => state.user.fetchProductBySupplierId
  //   );
  //   const fetchPurchasingOrder = useSelector(
  //     (state) => state.user.fetchPurchasingOrder
  //   );
  const fetchPoList = useSelector((state) => state.user.PoList);
  const PO_Confirmation = useSelector((state) => state.user.approvePO);

  // useEffect(() => {
  //   if (supplierid) {
  //     dispatch(FetchProductBysupplierid(supplierid));
  //   }
  // }, [dispatch, supplierid]);

  const orderid = window.localStorage.getItem("orderid");

  const PaginationChange = (event) => {
    setPageNumber(event.selected);
  };

  const handleSelectAll = () => {
    const previous = radioSelections;
    if (orderSelectAll === false) {
      if (previous.every((selection) => selection === true)) {
        //   setRadioSelections(new Array(previous.length).fill(false));
        setOrderSelectAll(true);
      } else {
        setRadioSelections(new Array(previous.length).fill(true));
        setOrderSelectAll(true);
      }
    } else {
      setRadioSelections(new Array(previous.length).fill(false));
      setOrderSelectAll(false);
    }
  };

  const approvePO = () => {
    const data = poList.filter(
      (quote, index) => radioSelections[index] === true
    );
    dispatch(ApprovePO(data));
    setLoading(true);
  };

  const handleRadioSelection = (index) => {
    const existingSelections = [...radioSelections];
    existingSelections[index] = !existingSelections[index];
    setRadioSelections(existingSelections);
    if (existingSelections.every((selection) => selection === true)) {
      setOrderSelectAll(true);
    }
    if (existingSelections.some((selection) => selection === false)) {
      setOrderSelectAll(false);
    }
  };

  useEffect(() => {
    dispatch(GetPOList(quoteId));
  }, []);

  useEffect(() => {
    if (
      Object.keys(PO_Confirmation).length > 0 &&
      PO_Confirmation.status === true
    ) {
      setLoading(false);
    }
  }, [PO_Confirmation]);

  useEffect(() => {
    if (fetchPoList.status === true) {
      setPOList(fetchPoList.data);
    }
  }, [fetchPoList]);

  useEffect(() => {
    if (fetchPoList.status === true) {
      setRadioSelections(new Array(fetchPoList?.data?.length).fill(false));
    }
  }, [fetchPoList]);

  useEffect(() => {
    if (PO_Confirmation && PO_Confirmation.status === true) {
      setPOApproved(true);
    }
  }, [PO_Confirmation]);

  useEffect(() => {
    let timer;
    if (poApproved === true) {
      timer = setTimeout(() => {
        setPOApproved(false);
        history.push("/quote");
        window.location.reload();
      }, 10000);
    }
    return () => clearTimeout(timer);
  }, [poApproved]);

  //   useEffect(() => {
  //     if (orderid) {
  //       dispatch(FetchPurchasingOrder(orderid));
  //     }
  //   }, [dispatch, orderid]);

  // useEffect(() => {
  //   if (
  //     fetchProductBySupplierIdList != null &&
  //     fetchProductBySupplierIdList?.status
  //   ) {
  //     setFetchProductsData(fetchProductBySupplierIdList?.data);
  //   }
  // }, [ fetchProductBySupplierIdList ]);

  return (
    <div className="container-fluid main-wrapper mb-4">
      <div className="containerBox">
        <div className="stock-heading-box">
          <div
            className="stock-heading cursor-pointer"
            onClick={() => {
              history.push("/stock");
            }}
          >
            Stock
          </div>
          <div className="confirm-box-title2">
            <div className="title2"> Purchasing Orders From Quote</div>
            <div className="order-id">ID {purchaseOrderID}</div>
          </div>
        </div>
        <Header />
      </div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <button
          className="addQuoteBtn"
          style={{
            opacity: poApproved
              ? "0.5"
              : poList && poList.length === 0
              ? "0.5"
              : "1",
            display: "flex",
            justifyContent: "center",
            // marginRight: "15px",
            paddingRight: "25px",
          }}
          disabled={poList && poList.length === 0}
          onClick={approvePO}
        >
          <img
            src={packageIcon}
            style={{
              width: "clamp(16px, 1.171vw, 1.171vw)",
              height: "clamp(16px, 1.171vw, 1.171vw)",
            }}
          />
          {"Approve"}
        </button>
      </div>
      <div className="listMain">
        <section className="quoteListSectionMain2">
          <p className="list">Purchase order</p>
          <p className="list">Supplier</p>
          <p className="list">Total order</p>
          <p className="list">Project</p>
          {poApproved ? (
            <p className={`list listRadio`}>Select</p>
          ) : poList && poList.length === 0 ? (
            <p className={`list listRadio`}>Select</p>
          ) : (
            <p className={`list listRadio`}>
              Select All
              <input
                type="radio"
                name="selectAll"
                className="custom-radio"
                checked={orderSelectAll}
                onClick={handleSelectAll}
                //   value={orderSelectAll}
              />
            </p>
          )}
        </section>
        {!loading ? (
          !poApproved ? (
            <div>
              {" "}
              {poList?.length > 0 && (
                <div className="quote-list-overflow">
                  {poList?.map((quote, index) => {
                    return (
                      <SingleQuoteItem
                        index={index}
                        projectName={quote?.projectName}
                        supplierName={quote?.supplierName}
                        totalOrder={quote.totalOrder}
                        purchaseOrder={quote?.purchaseOrderId}
                        projectId={quote?.projectId}
                        quotesId={quote?.quotesId}
                        sectionId={quote?.sectionId}
                        supplierId={quote?.supplierId}
                        checked={radioSelections[index]}
                        onClick={handleRadioSelection.bind(null, index)}
                        quoteCode={quoteCode}
                        productPartId={quote?.productPartId}
                        product={quote}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          ) : (
            <div className={`po-approved quote-list-overflow`}>
              <span className="meh-icon">
                <img src={meh} alt="" />
              </span>
              <p className="great-job">Great Job !</p>
              <p>All Purchasing Orders were sent by email.</p>
              <p>
                Return to{" "}
                <span
                  className="quote-link"
                  onClick={() => {
                    setPOApproved(false);
                    history.push("/quote");
                    window.location.reload();
                  }}
                >
                  quotes
                </span>
              </p>
            </div>
          )
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="quote-list-overflow"
          >
            {" "}
            <img
              src={loadingIcon}
              alt=""
              style={{ width: "24px", height: "24px" }}
            />
          </div>
        )}
        {poList && poList.length === 0 && (
          <div
            className="row container mt-5 pt-5"
            style={{ marginBottom: "3rem" }}
          >
            <img
              src={smaliIcon}
              alt="smali"
              width={35}
              height={35}
              className="mt-5 "
            />
            <h6
              className="mt-1"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                textAlign: "center",
                color: "#707070",
              }}
            >
              Sorry.
              <br /> No results.
              {/* <br /> Try to refine your search or enter a new search. */}
            </h6>
          </div>
        )}
      </div>

      <div className="quotePageDiv">
        <section className="quotePageSec1" style={{ position: "relative" }}>
          <p>Items per page</p>
          <article
            className="quotePageArt"
            onClick={() => setActivePageOption(!activePageOption)}
            style={{ paddingLeft: "0", alignItems: "center" }}
          >
            <p>{itemsPerPage}</p>
            <img
              src={downarrow}
              style={{
                width: "10px",
                height: "6px",
                transform: activePageOption
                  ? "rotate(-180deg)"
                  : "rotate(0deg)",
                transitionDuration: "300ms",
              }}
            />
          </article>
          <article
            className="quotePageArt quotePageArt2"
            onClick={() => setActivePageOption(!activePageOption)}
            style={{
              position: "absolute",
              right: "0",
              bottom: "0",
              height: activePageOption ? "clamp(82px, 6.003vw, 6.003vw)" : "0",
              transitionDuration: "300ms",
              visibility: activePageOption ? "visible" : "none",
              paddingTop: activePageOption ? "11px" : "0",
            }}
          >
            <article
              style={{
                display: activePageOption ? "flex" : "none",
                flexDirection: "column",
                gap: "10px",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontWeight: itemsPerPage === 10 ? "800" : "700",
                  color: itemsPerPage === 10 ? "#95A7C6" : "#333333",
                }}
                onClick={() => setItemsPerPage(10)}
              >
                10
              </p>
              <p
                style={{
                  fontWeight: itemsPerPage === 20 ? "800" : "700",
                  color: itemsPerPage === 20 ? "#95A7C6" : "#333333",
                }}
                onClick={() => setItemsPerPage(20)}
              >
                20
              </p>
            </article>
            <article
              className="quotePageArt"
              onClick={() => setActivePageOption(!activePageOption)}
              style={{
                paddingLeft: "0",
                alignItems: "center",
                display: activePageOption ? "flex" : "none",
              }}
            >
              <p
                style={{
                  fontWeight: itemsPerPage === 50 ? "800" : "700",
                  color: itemsPerPage === 50 ? "#95A7C6" : "#333333",
                }}
                onClick={() => setItemsPerPage(50)}
              >
                50
              </p>
              <img
                src={downarrow}
                style={{
                  width: "10px",
                  height: "6px",
                  transform: activePageOption
                    ? "rotate(-180deg)"
                    : "rotate(0deg)",
                  transitionDuration: "300ms",
                }}
              />
            </article>
          </article>
        </section>
        <section className="quotePageSec2">
          <div className="table-filter-info-member">
            <ReactPaginate
              nextLabel=""
              forcePage={pageNumber}
              disableInitialCallback={true}
              onPageChange={PaginationChange}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={totalPages}
              previousLabel=""
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="d-none"
              nextClassName="d-none"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="quote-pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

const SingleQuoteItem = ({
  index,
  purchaseOrder,
  supplierName,
  totalOrder,
  projectName,
  projectId,
  quotesId,
  sectionId,
  supplierId,
  checked,
  onClick,
  quoteCode,
  productPartId,
  product,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {}, [quotesId, sectionId]);
  return (
    <>
      <section
        className="quoteListSection2"
        style={{
          marginTop: "16px",
          position: "relative",
        }}
        key={index}
      >
        <p
          className="quoteListText"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push({
              pathname: `/add-purchasing-order`,
              state: {
                projectId: projectId,
                supplierid: supplierId,
                projectname: projectName,
                suppliername: supplierName,
                quoteId: quotesId,
                totalExclusive: totalOrder.toFixed(2),
                productPartId: productPartId,
                fromQuotes: true,
                product,
              },
            });
          }}
        >
          {purchaseOrder}
        </p>
        <p className="quoteListText">{supplierName}</p>
        <p className="quoteListText">{`€${Number(totalOrder).toFixed(2)}`}</p>
        <p className="quoteListText">{projectName}</p>
        <div className="radio-selection-main">
          <input
            type="radio"
            checked={checked}
            onClick={onClick}
            className="radio-selection"
          />
        </div>
      </section>
    </>
  );
};

export default PurchaseOrder;
